import React from 'react';
import Loader from 'components/Loader';
import { imgBaseURL } from './apis/Admin';

const monthArray = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const getFormatedDate = isoDate => {
  const fDate = new Date(isoDate);
  const year = fDate.getFullYear();
  const month = fDate.getMonth();
  let date = fDate.getDate();

  if (date < 10) {
    date = `0${date}`;
  }

  return `${year}-${monthArray[month]}-${date}`;
};

export const startOfMonth = date => {
  return new Date(date.getFullYear(), date.getMonth(), 1);
};
export const getImg = val => {
  return `${imgBaseURL}/${val}`;
};
export const showLoader = (val,bg) => {
  console.log(val, 'showLoader');
  if (val) {
    return <Loader loader="ClipLoader" bg={bg} />;
  }
};
